export default __webpack_public_path__ + "static/media/message-card-image.cd015adb.png";